import { makeAutoObservable } from "mobx";

export class AppStore {
  isAppReady: boolean = false;
  listsArePreloaded: boolean = false;
  redirectToPath: string | null = null;

  constructor() {
    makeAutoObservable(this);
    this.isAppReady = true;
  }

  setAppReady(value: boolean) {
    this.isAppReady = value;
  }
}
